import dayjs from 'dayjs';
const currentDate = new Date();
// 获取一周前前的日期
function getPreviousWeekDate(date) {
  // 获取当前日期
  let currentDate = new Date(date);

  // 获取一周前的日期
  currentDate.setDate(currentDate.getDate() - 7);

  return currentDate;
}
const oneWeekAgo = getPreviousWeekDate(currentDate);
const oneWeekDay = dayjs(oneWeekAgo).format('YYYY-MM-DD');

export default oneWeekDay;
